export default {
  title: {
    en: 'when do you want to notify the recipient of your gift?',
  },
  emailBox: {
    title: {
      en: 'Send an email right now',
    },
    buttonTitle: {
      en: 'Send now',
    },
  },
  calendarBox: {
    title: {
      en: 'Choose a specific date',
    },
    buttonTitle: {
      en: 'Choose date',
    },
  },
}
